import styled from "react-emotion";

const ErrorMessage = styled("div")`
  text-align: left;
  margin-top: 10px;
  font-size: 16px;
  color: red;
`;

export default ErrorMessage;


// WEBPACK FOOTER //
// ./src/elements/ErrorMessage.tsx